<template>
  <div>
    <div v-for="(dateRecord, index) in actualDates" class="flex">
      <div>
        <select @change="updateActualDate(index)" class="form-control" v-model="dateRecord.monthSelected"
                :disabled="dateRecord.toRemove">
          <option v-for="ind in 12" :key="ind" :value="ind">{{ ind < 10 ? '0' + ind : ind }}</option>
        </select>
      </div>
      <div>
        <select @change="updateActualDate(index)" class="form-control" v-model="dateRecord.yearSelected"
                :disabled="dateRecord.toRemove">
          <option v-for="year in yearsRange" :key="year" :value="year">{{ year }}</option>
        </select>
      </div>
      <template v-if="!componentOptions?.hide?.tillPart">
        <div><span class="text_between">до</span></div>
        <div>
          <input type="text" class="form-control opacity" :name="`validDate_${index}`"
                 :disabled="dateRecord.toRemove"
                 placeholder="Дата"
                 v-validate="'date_format:dd.MM.yyyy'"
                 data-vv-as="Дата"
                 v-model="dateRecord.actual_date">
          <small class="form-text text-danger" v-if="errors.has(`validDate_${index}`)">
            {{ errors.first(`validDate_${index}`) }}
          </small>
          <datepicker ref="calendar" :value="getProperDate(dateRecord.actual_date)" :language="locality"
                      :monday-first="true"
                      input-class="form-control hidden"
                      @change="(e) => dateSelected(e, index)"
                      @selected="(e) => dateSelected(e, index)"
                      format="dd.MMM.yyyy"/>
        </div>
        <div>
          <button @click="openCalendar(index)" :disabled="dateRecord.toRemove" type="button"
                  class="btn btn-info calendarAction opacity">
            <i class="icon-fa icon-fa-calendar calendarAction"></i>
          </button>
        </div>
        <div>
          <input type="text" v-model="dateRecord.comment" placeholder="Комментарий" class="form-control">
        </div>
        <div class="checkbox_div">
          <template v-if="!dateRecord.is_active && dateRecord.status === 2">
            <label>ожидается в поступлении</label>
          </template>
          <template v-else>
            <label class="pointer"><input v-model="dateRecord.info_only" type="checkbox"/> не выгружать на сайты</label>
          </template>
        </div>
      </template>
      <div>
        <button @click="removeRecord(index)" type="button" class="btn btn-outline-danger">
          <i class="icon-fa icon-fa-remove"></i>
        </button>
      </div>
    </div>
    <div class="text-right">
      <button @click="addNewRecord" class="btn btn-sm btn-outline-info m-1">Добавить</button>
      <vue-ladda @click="updateDates()" button-class="btn btn-success btn-sm ladda-button"
                 data-style="zoom-in"
                 :loading="btnLoading">Сохранить
      </vue-ladda>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import {en, ru} from 'vuejs-datepicker/dist/locale'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import * as _ from 'lodash'

export default {
  components: {
    Datepicker,
    VueLadda
  },
  props: ['dates', 'drugId', 'options', 'componentOptions'],
  data() {
    return {
      btnLoading: false,
      locality: ru,
      actualDates: [],
      yearsRange: [],
      defaultActualDate: moment().add(6, 'month').format('DD.MM.YYYY')
    }
  },
  watch: {
    dates() {
      let records = this.actualDates.filter((d) => !d.id)
      let arr = [...this.dates, ...records]
      arr = arr.reduce((acc, r) => {
        if (!acc.find((a) => a.expire_date == r.expire_date) && r.expire_date) {
          acc.push(r)
        }
        return acc
      }, [])
      // this.formatRecords(this.dates);
      this.formatRecords(arr)
    },
  },
  mounted() {
    const currentYear = new Date().getFullYear()
    this.yearsRange = Array(currentYear + 8 - currentYear + 1).fill().map((_, idx) => currentYear + idx)
    if (this.dates) {
      this.formatRecords(this.dates)
    }
    this.addNewRecord()
  },
  methods: {
    updateActualDate(index) {

      // А1) срок годности текущий месяц и сегодня 01-10 число - актуальность 15 число текущего месяца
      // А2) срок годности текущий месяц и сегодня 11-17 число - актуальность 22 число текущего месяца
      // А3) срок годности текущий месяц и сегодня >17 числа - актуальность последний день текущего месяца
      // Б1) 1 месяц от текущего - актуальность +12 дней к текущей дате
      // Б2) 2 месяца от текущего - актуальность 10 число следующего за текущем месяца
      // В) 3-4 месяца от текущего месяца - актуальность последнее число следующим за текущим месяца
      // Г) 5-7 месяцев - актуальность 60 дней
      // Д) 8-10 месяцев - 90 дней
      // Е) 11-16 месяцев - 120 дней
      // Ж) 17 - 30 месяцев - 180 дней
      // З) 31-48 месяцев - 270 дней
      // И) более 48 месяцев - 365 дней

      // console.log(index, this.actualDates[index]);
      let {monthSelected, yearSelected} = this.actualDates[index]
      if (!monthSelected || !yearSelected) return
      if (monthSelected < 10) monthSelected = '0' + monthSelected
      let diff = moment().diff(yearSelected + '-' + monthSelected + '-01', 'days')
      this.actualDates.forEach((d, i) => {
        if (i !== index) {
          if (d.monthSelected == monthSelected && d.yearSelected == yearSelected) {
            toastr['warning']('срок годности задублирован', 'Ошибка!')
            return
          }
        }
      })
      if (diff >= 0) {
        this.actualDates[index].actual_date = moment().format('DD.MM.YYYY')
      } else {
        diff *= -1
        const months = Math.round(diff / 30)
        if (!this.options) return
        const monthKeys = Object.keys(this.options).sort((a, b) => b - a)
        let newDate = null
        monthKeys.forEach((k, i) => {
          if (newDate) return
          if (i === 0 && months > k || (!newDate && months >= k)) {
            if (this.options[k].day === 'last' || this.options[k].month) {
              newDate = moment()
              if (this.options[k].month) {
                newDate = newDate.add(this.options[k].month, 'month')
              }
              if (this.options[k].day === 'last') {
                newDate = newDate.endOf('month')
              } else {
                newDate = newDate.set('date', 0).add(this.options[k].day, 'days')
              }
              newDate = newDate.format('DD.MM.YYYY')
            } else {
              newDate = moment().add(this.options[k].day, 'days').format('DD.MM.YYYY')
            }
          }
        })
        this.actualDates[index].actual_date = newDate ? newDate : moment().add(6, 'month').format('DD.MM.YYYY')
      }
    },
    getProperDate(date) {
      return moment(date, 'DD.MM.YYYY').toISOString()
    },
    formatRecords(data) {
      this.actualDates = data.map((d) => {
        d.monthSelected = +this.moment(d.expire_date, 'MM')
        d.yearSelected = this.moment(d.expire_date, 'YYYY')
        d.timestamp = Math.round(new Date(d.actual_date).getTime() / 100),
          d.actual_date = d.expire_date ? this.moment(d.actual_date) : this.defaultActualDate
        d.toRemove = false
        return d
      })
      this.actualDates = _.orderBy(this.actualDates, 'expire_date', 'asc')
    },
    removeRecord(index) {
      this.actualDates[index].toRemove = !this.actualDates[index].toRemove
      this.actualDates = [...this.actualDates]
    },
    addNewRecord() {
      this.actualDates.push({
        'expire_date': null,
        actual_date: null,
        'toRemove': false
      })
    },
    async updateDates() {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      let errors = []
      this.actualDates.forEach((d, i) => {
        if (!d.toRemove) {
          this.actualDates.forEach((dd, ii) => {
            if (i !== ii && !dd.toRemove) {
              if (d.monthSelected && d.yearSelected && d.monthSelected == dd.monthSelected && d.yearSelected == dd.yearSelected) {
                toastr['warning']('срок годности задублирован', 'Ошибка!')
                errors.push('срок годности задублирован')
                return
              }
            }
          })
          if (!d.actual_date && d.monthSelected && d.yearSelected) {
            // toastr['warning']('не заполнена актуальная дата', 'Ошибка!')
            // errors.push('не заполнена актуальная дата')
            // return
          }
        }
      })

      if (errors.length) {
        errors.forEach((e) => {
          toastr['warning'](e, 'Ошибка!');
        });
        return
      }

      if (!this.actualDates.length) return
      this.btnLoading = true
      let {data} = await api.post('/drugs/updateExpireDates', {
        drugId: this.drugId,
        actualDates: this.actualDates
      })

      if (data.success && data.dates) {
        this.formatRecords(data.dates)
        toastr['success']('Обновлено!')
      } else {
        toastr['warning'](data.message, 'Ошибка!')
      }
      this.addNewRecord()
      this.btnLoading = false
    },
    dateSelected(e, index) {
      let diff = moment(e).diff(this.actualDates[index].yearSelected + '-' + this.actualDates[index].monthSelected + '-01', 'days')
      if (moment().diff(e, 'day') >= 0) {
        this.actualDates[index].actual_date = moment().add(5, 'days').format('DD.MM.YYYY')
        return
      }
      if (diff >= 0) {
        this.updateActualDate(index)
      } else {
        this.actualDates[index].actual_date = moment(e).format('DD.MM.YYYY')
      }
    },
    openCalendar(index) {
      this.$refs.calendar.map((c, i) => {
        if (i !== index) {
          c.showDayView = false
        }
      })
      this.$refs.calendar[index].showCalendar()
    },
    moment: function (date, format = 'DD.MM.YYYY') {
      if (!date) return
      return moment(date).format(format)
    },
  }
}

</script>

<style scoped>
.opacity {
  opacity: .4;
}

.text_between {
  padding: 0 10px;
  vertical-align: -webkit-baseline-middle;
}

.btn-sm {
  font-size: 14px;
  padding: 2px 5px !important;
}

.checkbox_div label {
  margin-bottom: 0;
}

.checkbox_div {
  padding: 5px;
  align-self: center;
}
</style>
